/**
 * "Vedi come": chi amministra guarda l'applicazione con gli occhi di una persona, per aiutarla.
 *
 * Qui c'e' solo lo stato, chi si sta guardando, e non le chiamate, che stanno in vediComeAzioni.js:
 * questo modulo lo importano api.js, keycloak.js e spazioService.js, e un modulo che a sua volta
 * importasse api chiuderebbe l'anello degli import.
 *
 * Vive in sessionStorage, cioe' nella sola scheda in cui e' cominciato: le altre schede di chi
 * amministra restano sue. Per la stessa ragione, durante il "vedi come" anche lo spazio attivo si
 * tiene nella scheda (deposito): localStorage e' condiviso, e le altre schede si ritroverebbero
 * lo spazio della persona guardata.
 */

const CHIAVE = "zoelia.vediCome";
const CHIAVE_AVVISO = "zoelia.vediCome.avviso";
/** Lo spazio scelto mentre si guarda: la stessa chiave di spazioService, che qui non si puo' importare. */
const CHIAVE_SPAZIO = "zoelia_spazio_attivo";

/** L'intestazione che il backend legge (FiltroVediCome). */
export const INTESTAZIONE = "X-Zoelia-Vedi-Come";

/** Il codice del 409 con cui il backend dice che il "vedi come" non c'e' piu'. */
export const CODICE_TERMINATO = "VEDI_COME_TERMINATO";

function leggi() {
  if (typeof window === "undefined") return null;
  try {
    const grezzo = window.sessionStorage.getItem(CHIAVE);
    const stato = grezzo ? JSON.parse(grezzo) : null;
    return stato && stato.persona ? stato : null;
  } catch (e) {
    return null;
  }
}

export const vediCome = {
  /** Vero se in questa scheda si sta guardando come un'altra persona. */
  attivo() {
    return leggi() !== null;
  },

  /** { persona, nome, email, dal } di chi si sta guardando, o null. */
  stato() {
    return leggi();
  },

  imposta(stato) {
    try {
      window.sessionStorage.removeItem(CHIAVE_SPAZIO);
      window.sessionStorage.setItem(CHIAVE, JSON.stringify({
        persona: stato.persona,
        nome: stato.nome || stato.email || stato.persona,
        email: stato.email || null,
        dal: stato.dal || null,
      }));
    } catch (e) {
      // sessionStorage non disponibile: non puo' partire, e la pagina ricaricata non lo trova.
    }
  },

  pulisci() {
    try {
      window.sessionStorage.removeItem(CHIAVE);
      window.sessionStorage.removeItem(CHIAVE_SPAZIO);
    } catch (e) {
      // niente da pulire
    }
  },

  /** Chiude lasciando un messaggio da mostrare dopo il ricaricamento, che altrimenti lo perderebbe. */
  chiudiConAvviso(messaggio) {
    this.pulisci();
    try {
      if (messaggio) window.sessionStorage.setItem(CHIAVE_AVVISO, messaggio);
    } catch (e) {
      // senza sessionStorage il messaggio si perde: si torna comunque se stessi
    }
  },

  /** Il messaggio lasciato da chiudiConAvviso, una volta sola. */
  prendiAvviso() {
    try {
      const messaggio = window.sessionStorage.getItem(CHIAVE_AVVISO);
      window.sessionStorage.removeItem(CHIAVE_AVVISO);
      return messaggio;
    } catch (e) {
      return null;
    }
  },

  /** Dove tenere lo spazio attivo: nella scheda mentre si guarda, altrimenti in localStorage come sempre. */
  deposito() {
    return leggi() !== null ? window.sessionStorage : window.localStorage;
  },
};

export default vediCome;
